module.exports = __webpack_public_path__ + "img/mastercard.899d3062.svg";